module.exports = __webpack_public_path__ + "img/66.021cc8a3.jpg";